// extracted by mini-css-extract-plugin
export default {"page":"PaginationItem_page__gQVvo","step":"PaginationItem_step__vrR4C","separator":"PaginationItem_separator__MqsAp"};